// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titleText___UcVwd{font-size:22px}.outputText___IDJ7o{font-weight:380;font-size:14px}.nameField___24XES{width:490px}.descriptionField___B1nl6{width:1000px}\n", "",{"version":3,"sources":["webpack://./src/components/EditVelocityForm/EditVelocityForm.css"],"names":[],"mappings":"AAAA,mBACE,cAAA,CAGF,oBACE,eAAA,CACA,cAAA,CAGF,mBACE,WAAA,CAGF,0BACE,YAAA","sourcesContent":[".titleText {\n  font-size: 22px;\n}\n\n.outputText {\n  font-weight: 380;\n  font-size: 14px;\n}\n\n.nameField {\n  width: 490px;\n}\n\n.descriptionField {\n  width: 1000px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": "titleText___UcVwd",
	"outputText": "outputText___IDJ7o",
	"nameField": "nameField___24XES",
	"descriptionField": "descriptionField___B1nl6"
};
export default ___CSS_LOADER_EXPORT___;
